@use "../../styles/breakpoint.module.scss" as *;

.panel {
    grid-column: 2 / span 10;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.heading {
    font: var(--font-h-48);
    margin-bottom: var(--spacer-8);
}

.subheading {
    color: var(--form-label-color);
    font: var(--font-p-18);
    margin-bottom: var(--spacer-32);
}

// Lay the form out in two columns
.form {
    // Selectors target LocalContactForm's CSS Module class names by substring.
    form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0 var(--spacer-32);

        > input[type="hidden"],
        > template {
            display: none;
        }

        > [class*="input"] {
            grid-column: span 1;
        }

        > [class*="input"]:has(textarea) {
            grid-column: 1 / -1;
        }

        > [class*="legalWrapper"],
        > [class*="submitContainer"] {
            grid-column: 1 / -1;
        }

        > [class*="legalWrapper"] {
            margin-block: 0 var(--spacer-24);
        }

        @media ($below-tablet) {
            grid-template-columns: 1fr;
        }
    }

    textarea {
        min-height: 80px;
    }

    p {
        color: var(--color-contrast-subtle);
        font: var(--font-p-12);
    }
}
